import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { LocationSetsComponent } from '@emm/management/components/location-sets/location-sets.component';

@Injectable({
    providedIn: 'root'
})
export class ConfirmLocationSetsDeactivateGuard  {

    canDeactivate(
        component: LocationSetsComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return component
            .checkIfItemHasChanges(component.prevLocationSet)
            .pipe(take(1));
    }

}
